

























import BaseComponent from '@/core/base.component';
import { Component, Prop } from 'vue-property-decorator';
@Component({
  name: 'FounderConsultConfirmDialog',
})
export default class FounderConsultConfirmDialog extends BaseComponent {
  @Prop({ required: true }) readonly dialog: boolean;

  toggle() {
    this.$emit('update:dialog', !this.dialog);
  }
  agree() {
    this.toggle();
    this.$emit('agree');
  }
}
